<template>
    <BaseTrigger type="url" :label="label" @click="OnTriggerClicked" :sound="sound">
        <slot></slot>
    </BaseTrigger>
</template>

<script>
import BaseTrigger from '../BaseTrigger.vue';

export default {
    props: ['url', 'label', 'sound'],
    components: {
        BaseTrigger
    },
    mounted() {
        if (this.url == undefined) {
            console.error("URL trigger is missing a 'url' property");
        }
    },
    methods: {
        OnTriggerClicked() {
            window.open(this.url, "_blank");
        }
    }
}
</script>

<style lang="scss">
.trigger-url {
    // background-image: url('../../assets/images/trigger-green.svg') !important;
}
</style>